import React, { useState } from 'react';
import { CSSZSickLeaveCertificate } from '../../Interfaces/CSSZ.interface';
import moment from 'moment';
import CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryForm, {
	CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryFormValues,
} from './CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryForm';
import useCSSZSickLeaveForm from '../Hooks/useCSSZSickLeaveForm';
import Loading from '../../../../Components/Loading';
import JobWaiting from '../../../Base/Components/Job/JobWaiting';
import useNotification from '../../../../Hooks/useNotification.hook';

interface Props {
	item: CSSZSickLeaveCertificate;
	patientId: string;
	onCreate: (jobId?: string) => void;
}

const CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountry: React.FC<
	Props
> = ({ item, patientId, onCreate }) => {
	const [waitingJobId, setWaitingJobId] = useState<string | null>(null);
	const { showNotificationAlert, showNotificationSuccess } = useNotification();
	const { post, isLoading } = useCSSZSickLeaveForm({
		patientId,
		sickLeaveCertificate: item,
		endpoint:
			'zadost-o-udeleni-souhlasu-ke-zmene-pobytu-z-duvodu-pobytu-v-cizine',
	});

	const handleSubmit = async (
		values: CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryFormValues,
	) => {
		await post(values, (jobId?: string) => {
			if (jobId) {
				setWaitingJobId(jobId);
			} else {
				onCreate();
			}
		});
	};

	if (waitingJobId) {
		return (
			<JobWaiting
				jobId={waitingJobId}
				onJobSuccess={() => {
					setWaitingJobId(null);
					showNotificationSuccess({
						content:
							'component.CSSZSickLeaveCertificateDetailControls.requestForChangeAddressBecauseBeingOutsideOfCountrySuccess',
					});
					onCreate();
				}}
				onJobFailed={() => {
					setWaitingJobId(null);
					showNotificationAlert({
						content: 'component.jobWaiting.jobFailed',
					});
				}}
				timeout={15000}
				waitingMessage='component.jobWaiting.waitingTitle'
			/>
		);
	}

	if (isLoading) {
		return <Loading />;
	}

	return (
		<CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryForm
			onSubmit={handleSubmit}
			defaultValues={{
				dateFrom: moment().format(),
			}}
		/>
	);
};

export default CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountry;
